module.exports = __webpack_public_path__ + "img/AssaAbloy_ikon_utbytesguide.ed1086d8.png";